<script>
export default {
  name: 'IdenticalFormulationItem'
}
</script>

<script setup>
import { ref, computed } from 'vue';
import { url } from '@/config/urls';

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  index: {
    type: Number
  },
  isConfirm: {
    type: Boolean,
    default: false
  },
  orderAmount: {
    type: Number
  },
  orderInputMap: {
    type: Map
  },
  fileIconUrl: {
    type: String,
    default: url.static.fileIcon
  },
  pmdaBaseUrl: {
    type: String,
    default: url.external.pmda
  },
  reorderFlg: {
    type: Boolean,
    default: false
  }
})

const tableRowId = computed({
  get() {
    if (props.isSearch) {
      return `identicalFormulationRow_${props.index}`;
    }else {
      return 'orderItemInfoRow';
    }
  }
})

const goodsName = computed({
  get() {
    return props.item.formalGoodsName1 + props.item.formalGoodsName2;
  }
})

const genericDrugWord = computed({
  get() {
    if(props.item.generic == '1') {
      return 'GE';
    }else {
      return '';
    }
  }
})

const getOrderMemory = computed({
  get() {
    if (0 != props.orderInputMap.size) {
      let orderId = 'orderIndex' + props.item.janCode;
      if (props.orderInputMap.has(orderId)){
        return props.orderInputMap.get(orderId);
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
})

</script>

<template>
<tr :id="tableRowId">
  <td data-label="分類">{{ item.abbreviation }}</td>
  <td data-label="商品コード">{{ item.janCode }}</td>
  <td data-label="メーカー">{{ item.makerName }}</td>
  <td data-label="商品名" class="text-start">{{ goodsName }}</td>
  <td data-label="単位薬価">{{ item.unitDrugPrice.toFixed(2) }}</td>
  <td data-label="GE">{{ genericDrugWord }}</td>
  <td data-label="添付文書"><a target="_blank" :href="props.pmdaBaseUrl.replace('{GTIN}', props.item.salePackagingUnitCode)"><img :src="props.fileIconUrl" alt="PDF" class="com_icon_pdf1" /></a></td>
  <td data-label="商品情報">{{ item.goodsInfo }}</td>
  <td data-label="在庫">{{ item.stockSymbol }}</td>
  <template v-if="props.reorderFlg">
    <template v-if="props.isConfirm">
      <td data-label="発注数">{{ getOrderMemory }}</td>
    </template>
    <template v-else>
      <td data-label="発注数">
        <input :id="'orderIndex' + item.janCode" type="number" inputmode="numeric" min="1" max="999" placeholder="0" class="form-control com_form1 cnt1 text-end" :value="getOrderMemory">
      </td>
    </template>
  </template>
</tr>
</template>
